export default "__VITE_ASSET__9JWEmlNG__"